import { Link } from 'react-router';

export function GlamFlopsHero() {
  return (
    <section className="relative overflow-hidden min-h-[85vh] flex items-center justify-center">
      {/* Hero background image with subtle radial fade */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/hero.jpeg')" }}
      />
      {/* Gradient overlay to blend edges and add depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/50" />
      {/* Radial vignette for soft blending */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(0,0,0,0.7)_100%)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center pt-16 pb-24">
        <div className="inline-block px-10 py-8 rounded-2xl bg-black/30 backdrop-blur-md border border-white/10 shadow-[0_0_40px_rgba(212,168,83,0.15)]">
          <p className="text-2xl md:text-3xl max-w-xl mx-auto leading-relaxed drop-shadow-lg sparkle-text-subtle" style={{ fontFamily: "'Great Vibes', cursive" }}>
            Handmade in the Cayman Islands. Each pair uniquely crafted with crystals,
            rhinestones, and love — designed to make every step sparkle.
          </p>
          <p className="mt-6 text-2xl md:text-3xl sparkle-text" style={{ fontFamily: "'Great Vibes', cursive" }}>
            — Yulia —
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/inventory"
            className="inline-block bg-gradient-to-r from-[var(--color-glam-gold)] to-[var(--color-glam-gold-light)] text-[var(--color-glam-black)] px-8 py-3.5 rounded-full font-semibold text-base hover:shadow-[0_4px_24px_rgba(212,168,83,0.5)] transition-shadow"
          >
            Browse Collection
          </Link>
          <Link
            to="/preorder"
            className="inline-block border-2 border-[var(--color-glam-pink)] text-[var(--color-glam-pink)] px-8 py-3.5 rounded-full font-semibold text-base hover:bg-[var(--color-glam-pink)] hover:text-white transition-colors backdrop-blur-sm"
          >
            Custom Request
          </Link>
        </div>
      </div>
    </section>
  );
}
